/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_EventsInputs */

const en_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const de_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const es_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const fr_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évènements`)
};

const nl_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const it_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi`)
};

const pt_br2_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const pl_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia`)
};

const hu_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Események`)
};

const ro_admin_dashboard_events = /** @type {(inputs: Admin_Dashboard_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenimente`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Admin_Dashboard_EventsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_events = /** @type {((inputs?: Admin_Dashboard_EventsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_EventsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_events(inputs)
	if (locale === "de") return de_admin_dashboard_events(inputs)
	if (locale === "es") return es_admin_dashboard_events(inputs)
	if (locale === "fr") return fr_admin_dashboard_events(inputs)
	if (locale === "nl") return nl_admin_dashboard_events(inputs)
	if (locale === "it") return it_admin_dashboard_events(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_events(inputs)
	if (locale === "pl") return pl_admin_dashboard_events(inputs)
	if (locale === "hu") return hu_admin_dashboard_events(inputs)
	return ro_admin_dashboard_events(inputs)
});
export { admin_dashboard_events as "admin.dashboard.events" }